import { AdipaFormWidgetElement } from './define-form-element';

export function registerAdipaFormWidget() {
  if (typeof window === 'undefined') return;
  if (window.customElements.get('adipa-form-widget')) return;

  window.customElements.define('adipa-form-widget', AdipaFormWidgetElement);
}
